/**
 * Formats the SIRET number with spaces
 * @param siret the SIRET number
 * @returns the formatted value
 * @example `802 954 785 00028`
 */
export const formatSiret = (siret: string) => {
    const valueToUse = siret.replace(/\s/g, '');

    // split every 3 characters
    const regEx3chars = /\w{3}/g;
    regEx3chars.lastIndex = 0;

    const matches = [];
    let currentMatch = regEx3chars.exec(valueToUse);
    while (currentMatch !== null && matches.length < 3) {
        matches.push(currentMatch[0]);
        currentMatch = regEx3chars.exec(valueToUse);
    }
    // join the matches with a space between
    let formattedSiret = matches.join(' ');
    // get the rest of the string
    const restStartIndex = matches.length * 3;
    if (valueToUse.length >= restStartIndex + 1) {
        const restString = valueToUse.substring(restStartIndex);
        formattedSiret = `${formattedSiret}${formattedSiret !== '' ? ' ' : ''}${restString}`;
    }

    return formattedSiret;
};
